import React, { useState, useEffect, useCallback } from "react";

// Компонент пошуку
const SearchBar = React.memo(
  ({ value, onSearch, placeholder = "Пошук...", inputProps = {} }) => {
    const [inputValue, setInputValue] = useState(value || "");

    // Синхронізуємо зовнішнє value, якщо воно зміниться
    useEffect(() => {
      setInputValue(value || "");
    }, [value]);

    // Функція для обробки натискання Enter
    const handleKeyDown = useCallback(
      (e) => {
        if (e.key === "Enter") {
          onSearch(inputValue);
        }
      },
      [inputValue, onSearch]
    );

    // Функція для очищення пошуку
    const handleClear = () => {
      setInputValue("");
      onSearch("");
    };

    return (
      <div className="search-bar-container">
        <input
          className="search-bar"
          type="search"
          placeholder={placeholder}
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyDown={handleKeyDown}
          {...inputProps}
        />
        {inputValue && (
          <button type="button" className="clear-button" onClick={handleClear}>
            ✕
          </button>
        )}
      </div>
    );
  }
);

export default SearchBar;
